import React, { FC } from 'react';

import pluralize from 'pluralize';

import { useBusinessUnitLabelDisplayName } from 'src/apps/dashboard/helpers/BusinessUnitLabelHelper';

import { useBusinessUnitSelector } from '../../hooks/UseBusinessUnitSelector';
import { NavigationMenu } from '../navigation-menu/NavigationMenu';

import './BusinessUnitSelector.scss';

export const BusinessUnitSelector: FC = () => {
	const { options, selectedValue, handleSelectionChange, isReady } = useBusinessUnitSelector();
	const businessUnitDisplayName = useBusinessUnitLabelDisplayName();

	// Only render when we have a unitId (after redirect completes)
	if (!isReady) {
		return null;
	}

	return (
		<div className="business-unit-selector">
			<NavigationMenu
				id="business-unit-selector"
				label={pluralize(businessUnitDisplayName)}
				options={options}
				selectedValue={selectedValue}
				onSelectChange={handleSelectionChange}
				placeholder="Select a business unit"
				ariaLabel="Business unit navigation menu"
				className="business-unit-select"
			/>
		</div>
	);
};
